<template>
  <billing-report-panel
    report-key="appeals-deadline"
    route="/reports/billing-appeals-deadline"
    file-name="prazos-de-recurso.xlsx"
    :columns="columns"
    show-professional
  />
</template>

<script>
import BillingReportPanel from './BillingReportPanel.vue';

export default {
  components: {
    BillingReportPanel,
  },
  data() {
    return {
      columns: [
        'Lote',
        'Convênio',
        'Protocolo',
        'Enviado em',
        'Prazo do contrato',
        'Vence em',
        'Situação do prazo',
        'Glosas',
        'Guias',
        'Valor a recursar',
      ],
    };
  },
};
</script>
